module.exports = __webpack_public_path__ + "6068906832994102bb1489cb56981fb5.pdf";